import React, { Component } from "react";
import { getDateString } from "../../helpers";
import "./Navigation.css";
// Font Awesome import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faBullseye } from "@fortawesome/free-solid-svg-icons";

// Redux import
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actionCreators from "../../actions/actionCreators";
import { Link } from "react-router-dom";

import Submenu from "./Submenu";

const mapStateToProps = state => {
  return {
    menu: state.menu
  };
};

const mapDispachToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch);
};

class Navigation extends Component {
  state = {
    expandedIndex: null,
    openedFrom: null
  };

  handleClick = index => event => {
    if (this.state.expandedIndex === index) {
      this.props.collapseAll();
      const newState = { ...this.state };
      newState.expandedIndex = null;
      newState.openedFrom = null;
      this.setState(newState);
    }
    if (this.state.expandedIndex !== null) {
      this.props.collapseSubmenu(this.state.expandedIndex);
      const newState = { ...this.state };
      newState.expandedIndex = null;
      newState.openedFrom = null;
      this.setState(newState);
    }
    if (this.state.expandedIndex !== index) {
      this.props.expandSubmenu(index);
      const newState = { ...this.state };
      newState.openedFrom = this.props.location.pathname;
      newState.expandedIndex = index;
      this.setState(newState);
    }
  };

  createLinks = (element, index) => {
    const { day, monthday } = getDateString(element);
    const active = this.props.menu.menuItems[element].expanded;

    return (
      <li
        onClick={this.handleClick(element)}
        key={index}
        className={active ? "submenu-1-element active" : "submenu-1-element"}
      >
        <FontAwesomeIcon icon={faBullseye} /> {`${day} - ${monthday}`}
        {active ? (
          <Submenu
            location={this.props.location}
            day={element}
            data={this.props.menu.menuItems[element].children}
            index={index}
          />
        ) : null}
      </li>
    );
  };
  // On page change close all and open the open that should be open.
  componentDidUpdate(prevProps) {
    const path = this.props.location.pathname.split("/");
    const oldPath = prevProps.location.pathname.split("/");
    //Now lets check if we have open menus and we moved pages. Not just clicked.
    if (
      this.props.location.pathname !== this.state.openedFrom &&
      this.state.expandedIndex != null
    ) {
      //close all menu items.
      this.props.collapseAll();
      const newState = { ...this.state };
      newState.expandedIndex = null;
      newState.openedFrom = null;
      this.setState(newState);
    }
    //If we are in a page where we have potential open submenu open the correct ones.
    if (path[3]) {
      // Now check to see we actually moved pages.
      if (path[3] !== oldPath[3] || path[4] !== oldPath[4]) {
        //Now expand the menu we are on.
        this.props.expandSubmenu(path[3]);
        const newState = { ...this.state };
        newState.expandedIndex = path[3];
        newState.openedFrom = this.props.location.pathname;
        this.setState(newState);
      }
    }
  }

  render() {
    if (this.props.menu.length === 0) {
      return <p>Loading...</p>;
    }

    return (
      <div className="main-sidebar-nav">
        <ul>
          <li className="menu-element">
            <Link to="/app/instructor-dashboard">Main</Link>
          </li>
          <li className="menu-element">
            <Link to="/app/instructor-dashboard">
              <FontAwesomeIcon icon={faDesktop} />
              Dashboard
            </Link>
          </li>
          <ul className="submenu-1">
            {Object.keys(this.props.menu.menuItems).map(this.createLinks)}
          </ul>
        </ul>
      </div>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispachToProps
  )(Navigation)
);
